var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{class:'pipeline-line '+'weight'+_vm.weight},[_c('path',{attrs:{"stroke-width":"3.5","d":this.path,"fill":"none","marker-end":_vm.getMarkerEnd()}})])}
var staticRenderFns = []

export { render, staticRenderFns }